import React from 'react';
import { CellProps } from '../types';
import * as Styled from '../styles';

export const ScreenShotCell = ({ val }: CellProps) => (
  <Styled.CellStyled>
    <a
      href={val}
      target="_blank"
      rel="noreferrer"
    >
      View Image
    </a>
  </Styled.CellStyled>
);
